const postUrl = {
  createLead: 'lead',
};

export default postUrl;